import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

import {FavouriteTemplateOption, FavouriteTemplatePostData} from './types';

export type FavouriteTemplateFormFields = {
    favouriteTemplates: FavouriteTemplateOption[];
};

export type FavouriteTemplateSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type FavouriteTemplateErrorResponse = Api.Response.Failure;

export const usePutFavouriteTemplateEdit = (): UseMutationResult<
    FavouriteTemplateSuccessResponse,
    FavouriteTemplateErrorResponse,
    {
        favouriteTemplates: FavouriteTemplatePostData;
    }
> => {
    const locale = useLocale();

    return useMutation(({favouriteTemplates}) =>
        request({
            formData: toSnakeCase({
                favouriteTemplates,
            }),
            locale,
            method: 'PUT',
            url: '/settings/document/favourite-template/edit/',
        }),
    );
};
